import { Col } from 'antd';
import React from 'react'
import { translate } from 'react-i18next';
import { IconHelper } from '../../helpers/index';

const Wating = ({ t, roomName }) => {
    const { IconSpinner } = IconHelper
    return (
        <Col >
            <div className="participant-wating">
                <IconSpinner
                    style={{
                        width: 80,
                        height: 80,
                        margin: '0 auto',
                        display: 'block',
                        shapeRendering: 'auto'
                    }}
                />
            </div>
            <p className="participant-wating-text-waiting">{t('lobby_participant.wait_for_host')}</p>
            <p className="participant-wating-text-room-name">
                {`vroom.truevirtualworld.com/${roomName}`}
            </p>
        </Col>
    )
}

export default translate()(Wating)
